const doubleOptionMap = (variants, option1Name, option2Name) => {
  let map = {};

  const variantOptions = variants[0].node.selectedOptions;
  let option1Index;
  let option2Index;
  variantOptions.forEach((option, index) => {
    if (option.name.toLowerCase() === option1Name) option1Index = index;
    else if (option.name.toLowerCase() === option2Name) option2Index = index;
  });

  variants.forEach((variant) => {
    const option1 = variant.node.selectedOptions[option1Index].value;
    const option2 = variant.node.selectedOptions[option2Index].value;
    if (!map[option1]) {
      map[option1] = {};
    }
    map[option1][option2] = variant.node;
  });

  return map;
};

const singleOptionMap = (variants) => {
  let map = {};
  variants.forEach((variant) => {
    let option = variant.node.selectedOptions[0].value;
    map[option] = variant.node;
  });

  return map;
};

export const mapVariants = (variants, colors, sizes, styles) => {
  let variantMap = {};

  if (variants) {
    if (colors && sizes) {
      variantMap = doubleOptionMap(variants, "color", "size");
    } else if (colors && styles) {
      variantMap = doubleOptionMap(variants, "color", "style");
    } else if (sizes && styles) {
      variantMap = doubleOptionMap(variants, "style", "size");
    } else if (colors || sizes || styles) {
      variantMap = singleOptionMap(variants);
    }
  }

  return variantMap;
};

export const getProductOptions = (options) => {
  if (options) {
    let colors = null;
    let sizes = null;
    let styles = null;
    options.forEach((option) => {
      if (option.name.toLowerCase() === "color") {
        colors = option.values;
      } else if (option.name.toLowerCase() === "size" || option.name.toLowerCase() === "denominations") {
        sizes = option.values;
      } else if (option.name.toLowerCase() === "style") {
        styles = option.values;
      }
    });

    return { colors: colors, sizes: sizes, letters: styles };
  } else {
    return { colors: null, sizes: null, letters: null };
  }
};

export const selectVariant = (
  firstVariant,
  variantMap,
  selectedColor,
  selectedSize,
  selectedLetter,
  numAvailableSizes,
  setSelectedSize,
  colorMapping
) => {
  // Default first variant
  let selectedVariant = firstVariant;
  if (variantMap) {
    // If product has colors
    if (selectedColor) {
      if (numAvailableSizes > 1) {
        if (selectedSize) {
          // Selected variant depends on the selected color and selected size
          if (variantMap[selectedColor][selectedSize])
            selectedVariant = variantMap[selectedColor][selectedSize];
          // If user switches from one color to another color, but the selected size corresponding to the first color is not present as a variant for the second color
          else setSelectedSize(null);
        } 
        else {
          // If size hasn't been selected yet, then selected variant is the first size variant of the selected color
          if (variantMap[selectedColor])
            selectedVariant = Object.values(variantMap[selectedColor])[0];
        }
      } else if (numAvailableSizes === 1) {
        // If only 1 size on the product, then selected variant is only based on color
        if (variantMap[selectedColor])
          selectedVariant = Object.values(variantMap[selectedColor])[0];
      } else {
        // If no size on the product, then selected variant is only based on color
        if (variantMap[selectedColor])
          selectedVariant = variantMap[selectedColor];
      }
    }
    // If product is personalized (has letters)
    else if (selectedLetter) {
      if (numAvailableSizes > 1) {
        if (selectedSize) {
          // Selected variant depends on the selected letter and selected size
          if (variantMap[selectedLetter][selectedSize])
            selectedVariant = variantMap[selectedLetter][selectedSize];
          // If user switches from one letter to another letter, but the selected size corresponding to the first letter is not present as a variant for the second letter
          else setSelectedSize(null);
        } 
        else {
          // If size hasn't been selected yet, then selected variant is the first size variant of the selected letter
          if (variantMap[selectedLetter])
            selectedVariant = Object.values(variantMap[selectedLetter])[0];
        }
      } else if (numAvailableSizes === 1) {
        // If only 1 size on the product, then selected variant is only based on letter
        if (variantMap[selectedLetter])
          selectedVariant = Object.values(variantMap[selectedLetter])[0];
      } else {
        // If no size on the product, then selected variant is only based on letter
        if (variantMap[selectedLetter])
          selectedVariant = variantMap[selectedLetter];
      }
    }
    // If product has no colors or letters (styles) but sizes are present and a size has been selected
    else if (selectedSize) {
      if (variantMap[selectedSize]) selectedVariant = variantMap[selectedSize];
    }
  }

  return selectedVariant;
};

export const selectPLPVariant = (
  firstVariant,
  variantMap,
  selectedColor,
  selectedSize,
  selectedLetter,
  numAvailableSizes,
  setSelectedSize,
  handle
) => {
  // Default first variant
  let selectedVariant = firstVariant;

  if (variantMap) {
    // If product has colors
    if (selectedColor) {
      if (numAvailableSizes > 1) {
        if (selectedSize) {
          // Selected variant depends on the selected color and selected size
          if (variantMap[selectedColor] && variantMap[selectedColor][selectedSize]) {
            selectedVariant = variantMap[selectedColor][selectedSize];
          }
          // If user switches from one color to another color, but the selected size corresponding to the first color is not present as a variant for the second color
          else setSelectedSize(null);
        } 
      } else if (numAvailableSizes === 1) {
        // If only 1 size on the product, then selected variant is only based on color
        if (variantMap[selectedColor])
          selectedVariant = variantMap[selectedColor][selectedSize];
      } else {
        // If no size on the product, then selected variant is only based on color
        if (variantMap[selectedColor])
          selectedVariant = variantMap[selectedColor];
      }
    }
    // If product is personalized (has letters)
    else if (selectedLetter) {
      if (numAvailableSizes > 1) {
        if (selectedSize) {
          // Selected variant depends on the selected letter and selected size
          if (variantMap[selectedLetter] && variantMap[selectedLetter][selectedSize])
            selectedVariant = variantMap[selectedLetter][selectedSize];
          // If user switches from one letter to another letter, but the selected size corresponding to the first letter is not present as a variant for the second letter
          else setSelectedSize(null);
        } 
      } else if (numAvailableSizes === 1) {
        // If only 1 size on the product, then selected variant is only based on letter
        if (variantMap[selectedLetter])
          selectedVariant = variantMap[selectedLetter][selectedSize];
      } else {
        // If no size on the product, then selected variant is only based on letter
        if (variantMap[selectedLetter])
          selectedVariant = variantMap[selectedLetter];
      }
    }
    // If product has no colors or letters (styles) but sizes are present and a size has been selected
    else if (selectedSize) {
      if (variantMap[selectedSize]) selectedVariant = variantMap[selectedSize];
    }
  }
  if(selectedVariant)
    selectedVariant.handle = handle
  return selectedVariant;
};

export const getHexCodeData = (variantMap) => {
  if (variantMap) {
    let hexCodeArray = [];
    Object.keys(variantMap).forEach((color) => {
      const colorVariant = Object.values(variantMap[color])[0];
      if (colorVariant.hexColor) {
        hexCodeArray.push(
          colorVariant.hexColor.value.split(",").map((value) => value.trim())
        );
      }
    });

    return hexCodeArray;
  }
  return null;
};

export const groupImages = ({ mediaEdges }) => {
  const imageGroups = {};
  let video = null;
  let appendVideo = false;
  let videoObj={};
  mediaEdges.forEach((edge,index) => {
    if (edge.node.mediaContentType === "IMAGE") {
      const altText = (edge.node.image.altText != null) ? edge.node.image.altText?.toLowerCase() : null;
      if (!imageGroups[altText]) {
        imageGroups[altText] = [];
      }
      const image = {
        ...edge.node.image,
        previewImage: edge.node.previewImage,
      };
      imageGroups[altText].push(image);
    }

    // Check if video is there, and it is not at the first index
    if (edge.node.mediaContentType === "VIDEO" && mediaEdges.length > 1 && index!=0) {
      imageGroups[edge.node.previewImage.altText].push({ ...edge.node.sources, type: "video"});
      video = true;
    }
    // only video
    else if(index==0 && edge.node.mediaContentType === "VIDEO" && mediaEdges.length == 1){
      return { ...edge.node.sources, type: "video"};
    }
    //video is at the first index
    else if(edge.node.mediaContentType === "VIDEO" && mediaEdges.length > 1 && index==0){
      appendVideo=true;
      videoObj={ ...edge.node.sources, type: "video"};
      video=true;
    }

  });

  //video is added at first index in shopify & images later
  if(appendVideo){
    imageGroups[null].push(videoObj)
  }

  // move video to of array
  if (video) {
    if( mediaEdges.length > 1){
      Object.values(imageGroups[null]).forEach((group,index) => {
        if (group.type == "video") {
          imageGroups[null].push(imageGroups[null].splice(index, 1)[0]);
        }
      });
    }
  }

  return imageGroups;
};

// Check if the variant is fast shipping
export const checkIfFastShippingVariant = (variant) => {
  // variant is fast shipping when local item metafield has value "Local"
  if (variant?.local_item?.value === "Local") {
   return variant
  }
  return null;
};

// Generate array which contains colors which are eligible for fast shipping
export const generateFastShippingColors = (variantMap) => {
  let fastShippingColors = []
  Object.keys(variantMap)?.forEach((key) => {
    const variant = variantMap[key];
    Object.keys(variant)?.forEach((size) => {
      if (checkIfFastShippingVariant(variant[size])) {
        fastShippingColors.push(variant[size]?.hexColor?.value);
      }
    });
  });
  return fastShippingColors;
}

export const getColorMappingFromVariantMap = (variantsByColor) => {
  return Object.entries(variantsByColor).map(([colorName, sizeMap]) => {
    // Collect all variants for the current color
    const allVariants = Object.values(sizeMap);

    // Use the first variant as the default
    const firstVariant = allVariants[0];

    // Check for consistency across all size variants
    const baseColor = allVariants.every(variant => variant?.baseColor?.value === firstVariant?.baseColor?.value)
      ? firstVariant?.baseColor?.value
      : firstVariant?.baseColor?.value; // Fallback to the first variant's baseColor

    const hexColor = allVariants.every(variant => variant?.hexColor?.value === firstVariant?.hexColor?.value)
      ? firstVariant?.hexColor?.value
      : firstVariant?.hexColor?.value; // Fallback to the first variant's hexColor

    return {
      variantColor: colorName,
      hexColor: hexColor,
      baseColor: baseColor
    };
  });
};

export const getInitialOption = (firstVariant, optionName) => {
  return firstVariant?.selectedOptions?.find(
    (option) => option.name.toLowerCase() === optionName
  )?.value || null;
};
